document.addEventListener("DOMContentLoaded", () => {

  /* ------------------------------------
      MOBILE MENU OPEN / CLOSE
  ------------------------------------ */
  const menu = document.querySelector(".mobile-menu");
  const openBtn = document.querySelector(".mobile-menu-open");
  const closeBtn = document.querySelector(".mobile-menu-close");
  const overlay = document.querySelector(".mobile-menu-overlay");

  openBtn?.addEventListener("click", () => {
    menu.classList.add("active");
    overlay.classList.add("active");
  });

  function closeMenu() {
    menu.classList.remove("active");
    overlay.classList.remove("active");
  }

  closeBtn?.addEventListener("click", closeMenu);
  overlay?.addEventListener("click", closeMenu);


  /* ------------------------------------
      MOBILE MENU DROPDOWN (ONLY ONCE)
  ------------------------------------ */
  document.querySelectorAll(".dropdoune_click").forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      const parentItem = this.closest(".menu-item");
      const submenu = parentItem.querySelector(".submenu");

      // Hide other submenus
      document.querySelectorAll(".submenu").forEach(menu => {
        if (menu !== submenu) menu.style.display = "none";
      });

      // Remove open class from other triggers
      document.querySelectorAll(".dropdoune_click").forEach(btn => {
        if (btn !== this) btn.classList.remove("open");
      });

      // Toggle current submenu
      const isOpen = submenu.style.display === "block";
      submenu.style.display = isOpen ? "none" : "block";

      // Rotate arrow
      this.classList.toggle("open", !isOpen);
    });
  });


  /* ------------------------------------
      MOBILE → OPEN TABBED SECTION
  ------------------------------------ */
  const menuBtn = document.querySelector('.mobile-header__icon.menu-icon');
  const tabbedSection = document.querySelector('.tabbed-products-section');
  const body = document.body;

  menuBtn?.addEventListener('click', () => {
    body.classList.add('menu-open');
    tabbedSection.classList.add('show');
    menuBtn.classList.add('menu-opened');
  });


  /* ------------------------------------
      DESKTOP: HOVER MEGA MENU
  ------------------------------------ */
  if (window.innerWidth > 990) {
    const menuItems = document.querySelectorAll(".menu-list__list-item.maga_menu_hover");
    const popupSections = document.querySelectorAll(".tabbed-products-section");
    const overlayMenu = document.querySelector('.overlay_menu');

    let activeSection = null;

    menuItems.forEach((item, index) => {
      const popup = popupSections[index];
      if (!popup) return;

      function showPopup() {
        popupSections.forEach(sec => {
          sec.style.opacity = "0";
          sec.style.visibility = "hidden";
        });
        overlayMenu.style.opacity = ".6";
        overlayMenu.style.visibility = "visible";

        popup.style.opacity = "1";
        popup.style.visibility = "visible";

        activeSection = popup;
      }

      item.addEventListener("mouseenter", showPopup);
      item.addEventListener("click", showPopup);

      popup.addEventListener("mouseleave", () => {
        popup.style.opacity = "0";
        popup.style.visibility = "hidden";
        overlayMenu.style.opacity = "0";
        overlayMenu.style.visibility = "hidden";
        activeSection = null;
      });
    });
  }

  /* ------------------------------------
      TABS + SLIDERS
  ------------------------------------ */
  document.querySelectorAll(".tabbed-products-section").forEach(section => {
    const tabs = section.querySelectorAll(".tab");
    const contents = section.querySelectorAll(".tab-content");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        tab.classList.add("active");
        const target = section.querySelector(`#${tab.dataset.tab}`);
        if (target) target.classList.add("active");
      });
    });
  });

  // Initialize Swipers
  document.querySelectorAll(".tab-content").forEach(tab => {
    new Swiper(tab.querySelector(".product-slider"), {
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
        nextEl: tab.querySelector(".swiper-button-next"),
        prevEl: tab.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 10 },
        640: { slidesPerView: 2, spaceBetween: 15 },
        1024: { slidesPerView: 4, spaceBetween: 30 }
      }
    });
  });

});
